import type { MultiTabsSetting } from '/#/config';

import { computed } from 'vue';

import { useAppStore } from '@/store/modules/app';

export function useMultipleTabSetting() {
  const appStore = useAppStore();
  //标签页风格
  const getTabTheme = computed(() => appStore.getMultiTabsSetting.theme);

  const getShowMultipleTab = computed(() => appStore.getMultiTabsSetting.show);
  //显示
  const getShowQuick = computed(() => appStore.getMultiTabsSetting.showQuick);

  const getShowRedo = computed(() => appStore.getMultiTabsSetting.showRedo);

  const getShowFold = computed(() => appStore.getMultiTabsSetting.showFold);

  function setMultipleTabSetting(multiTabsSetting: Partial<MultiTabsSetting>) {
    appStore.setProjectConfig({ multiTabsSetting });
  }
  return {
    getTabTheme,
    setMultipleTabSetting,
    getShowMultipleTab,
    getShowQuick,
    getShowRedo,
    getShowFold,
  };
}
